<template>
	<div class="upcoming-events-page">
		<ResidentialUserNavbar />
		<div class="desktop-center upcoming-events-content">
			<div>
				<div
					class="events-banner"
					:class="{ 'events-banner-reminder': showEventReminder }"
				>
					<h2>Enjoy Exclusive 2ndKitchen Events!</h2>
					<div class="events-banner-subtitle">
						Events powered by 2ndKitchen brings highly rated local
						restaurants and their delicious food right to you!
					</div>
					<div class="events-highlights">
						<div>
							<img
								src="/images/2k-menu.png"
								alt="Popular Restaurants"
							/>
							<span>Rotation of Popular Restaurants</span>
						</div>
						<div>
							<img
								src="/images/2k-delivery.png"
								alt="Pre order"
							/>
							<span>Priority Pre Ordering</span>
						</div>
						<div>
							<img
								src="/images/2k-coupon.png"
								alt="Limited Menus"
							/>
							<span>Limited Time Menus</span>
						</div>
					</div>
				</div>
				<div class="event-reminder-cta" v-if="showEventReminder">
					<div>
						<div class="event-reminder-title">
							Excited About Events?
						</div>
						<div class="event-reminder-subtitle">
							Get a convenient notification the next time an event
							is scheduled!
						</div>
					</div>
					<button
						class="button button-primary button-auto"
						@click="eventReminderClicked"
					>
						<i class="sk-icon-bell-on-solid"></i>
						Notify Me
					</button>
				</div>
			</div>
			<div class="event-cards-container">
				<div class="event-cards-title">
					Upcoming Events at {{ businessName }}
				</div>
				<div v-if="events.length > 0 && !loading" class="event-cards">
					<EventCard
						v-for="(event, index) in events"
						:key="event.id"
						:event="event"
						:isUpcoming="index == 0"
					/>
				</div>
				<div v-else-if="!loading" class="sk-widget-alt">
					<div class="events-placeholder">
						<img
							src="/images/2k-empty-events-alt.png"
							alt="No Events Image"
						/>
						<div class="events-placeholder-info">
							There are no upcoming events at {{ businessName }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.desktop-center {
	max-width: 700px !important;
}

.upcoming-events-page {
	height: 100%;
	background: var(--sk-grey-bg);
}

.upcoming-events-content {
	padding: 0 10px;
	margin-top: 20px !important;
}

.events-banner {
	background: linear-gradient(
		180deg,
		var(--gR-base-90) 35.11%,
		var(--gR-base-80) 71.54%
	);
	border-radius: 5px;
	padding: 20px;
}

.events-banner-reminder {
	padding-bottom: 46px;
}

.events-banner h2 {
	font-size: 16px;
	font-weight: 600;
	color: var(--gR-white);
}

.events-banner .events-banner-subtitle {
	color: var(--gR-white);
	font-size: 12px;
	margin-bottom: 15px;
}

.events-highlights {
	display: flex;
	justify-content: space-between;
}

.events-highlights div {
	display: flex;
	align-items: center;
	height: 80px;
}

.events-highlights img {
	width: 45px;
	margin-right: 20px;
}

.events-highlights span {
	font-size: 12px;
	font-weight: 600;
	color: var(--gR-white);
}

.event-reminder-cta {
	background: var(--gR-white);
	border-radius: 5px;
	box-shadow: 0px 0px 2px rgba(136, 136, 136, 0.25);
	margin: -35px 25px 0 25px;
	position: relative;
	z-index: 1;
	padding: 20px 15px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.event-reminder-title,
.event-reminder-subtitle {
	font-size: 12px;
}

.event-reminder-title {
	font-weight: 600;
	color: var(--gR-base-80);
	margin-bottom: 5px;
}

.event-reminder-subtitle {
	color: var(--sk-grey3);
}

.event-reminder-cta .button {
	font-size: 10px;
	font-weight: 400;
	padding: 5px 20px;
}

.event-reminder-cta .button i {
	font-size: 10px;
	margin-right: 10px;
}

.event-cards-container {
	margin: 0 25px;
}

.event-cards {
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 30px;
}

.event-cards >>> .event-card:first-child {
	grid-column: span 2;
}

.event-cards-title {
	margin: 30px 0 25px 0;
	font-size: 14px;
	font-weight: 600;
	color: var(--gR-base-80);
}

.events-placeholder {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}

.events-placeholder img {
	margin-bottom: 27px;
	margin-top: 15px;
	width: 90px;
}

.events-placeholder-info {
	color: var(--sk-grey3);
	font-size: 12px;
	text-align: center;
}

@media only screen and (max-width: 700px) {
	.upcoming-events-content {
		padding: 0;
		margin: 0 !important;
	}

	.events-banner {
		border-radius: 0;
	}

	.events-highlights {
		flex-direction: column;
	}

	.event-reminder-cta {
		flex-direction: column;
		align-items: flex-start;
	}

	.event-reminder-subtitle {
		margin-bottom: 10px;
	}

	.event-cards-container {
		margin: 0 10px;
	}

	.event-cards {
		grid-template-columns: 1fr;
		margin-bottom: 30px;
	}

	.event-cards >>> .event-card:first-child {
		grid-column: span 1;
	}
}
</style>

<script>
import { EventBusEvents } from "@/enums/EventBusEvents"
import { NotificationType } from "@/enums/NotificationType"
import { UserNotificationType } from "@/enums/UserNotificationType"
import { eventBus } from "@/eventBus"
import loaderMixin from "@/mixins/loader-mixin"
import ResidentialUserNavbar from "@/components/navbars/ResidentialUserNavbar.vue"
import EventCard from "@/components/events/EventCard.vue"

export default {
	name: "UpcomingEvents",
	mixins: [loaderMixin],
	components: {
		EventCard,
		ResidentialUserNavbar
	},
	computed: {
		navbarTitle() {
			return "Upcoming Events"
		},
		businessName() {
			return this.$store.state.business && this.$store.state.business.name
				? this.$store.state.business.name
				: ""
		},
		loading() {
			return (
				this.$store.state.loading ||
				!this.$store.state.business ||
				this.$store.state.business.slug != this.$route.params.slug
			)
		},
		events() {
			return this.$store.state.businessEvents
				.filter((event) => {
					return event.isUpcoming
				})
				.sort((a, b) => {
					if (a.startTimestamp > b.startTimestamp) {
						return 1
					} else {
						return -1
					}
				})
		},
		showEventReminder() {
			const isUserLoggedIn =
				this.$store.state.user && this.$store.state.user.id != 0
			return (
				isUserLoggedIn &&
				(!this.$store.state.user.notifications ||
					!this.$store.state.user.notifications.find(
						(notification) =>
							notification.type ==
							UserNotificationType.UPCOMING_EVENT_SMS
					))
			)
		}
	},
	methods: {
		eventReminderClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Event Remind Me Clicked"
			})
			this.toggleLoader(true)
			this.$store
				.dispatch("updateUserNotification", {
					type: UserNotificationType.UPCOMING_EVENT_SMS,
					optIn: true
				})
				.then(() => {
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message:
							"You will receive a notification when a new event is available",
						type: NotificationType.SUCCESS
					})
				})
				.catch(() => {
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message: "An error occurred, please try again.",
						type: NotificationType.ERROR
					})
				})
				.finally(() => {
					this.toggleLoader(false)
				})
		}
	},
	watch: {
		loading: {
			immediate: true,
			handler(loading) {
				this.toggleLoader(loading)
			}
		}
	}
}
</script>
